import {PaymentElement} from '@stripe/react-stripe-js'
import type {StripePaymentElement, StripePaymentElementOptions} from '@stripe/stripe-js'
import Big from 'big.js'

import {useAccountInformationValue} from '@/auth/hooks/useAccountInformation'
import {useCountry} from '@/lib/locale/country'
import useCustomerSession from '@/lib/payment/hooks/useCustomerSession'
import {useSetElementsOptions} from '@/lib/payment/PaymentProvider'
import toStripeAmountNumber from '@/lib/payment/utils/toStripeAmountNumber'
interface Props {
  total: Big
  onReady?: (element: StripePaymentElement) => void
}

export default memo<Props>(function PaymentMethod({total, onReady}) {
  const [country] = useCountry()
  const account = useAccountInformationValue()

  const {data: customerSession} = useCustomerSession()

  const setElementsOptions = useSetElementsOptions()

  ;(function updateElementsOptions() {
    setElementsOptions(options => {
      options.mode = 'payment'
      options.setupFutureUsage = 'off_session' // vs on?
      if (customerSession) {
        options.customerSessionClientSecret = customerSession
      }
      options.amount = toStripeAmountNumber(total)
    })
  })()

  const paymentOptions = useMemo<StripePaymentElementOptions>(() => {
    return {
      layout: {
        type: 'tabs',
        defaultCollapsed: false,
        radios: true,
        spacedAccordionItems: true,
      },
      wallets: {
        applePay: 'auto',
        googlePay: 'auto',
      },
      defaultValues: {
        billingDetails: {
          name: account?.accountName ?? '',
          email: account?.email ?? '',
          address: {
            country,
          },
        },
      },
    }
  }, [account, country])

  return <PaymentElement options={paymentOptions} onReady={onReady} />
})
